import type { Activity, ActivityId } from '@gyym/sdk'

// アクティビティの並び順
// TODO: 将来的には `activity_orders` のようなテーブルを作って管理画面上から変更可能にする
const ACTIVITY_ORDER: ActivityId[] = [
  10, // 暗闇フィットネス
  1, // ホットヨガ
  24, // サウナ
  4, // ピラティス
  2, // ヨガ
  6, // サーキットトレーニング
  5, // マシンジム
  11, // スイミング
  3, // ボクシング
  21, // キックボクシング
  13, // サーフエクササイズ
  18, // エアリアルヨガ
  14, // ストレッチ
  7, // パーソナルトレーニング
  8, // ダンス・バレエ
  9, // サイクリング
  22, // ランニング
  15, // EMS
  17, // ボルダリング
  20, // トランポリン
  16, // エステ・セルフエステ
  19, // ゴルフ
  23, // テニス
  12, // その他
]

export const sortActivities = <T extends Activity>(activities: T[]) => {
  const data = [...activities]
  const priorityData: T[] = []

  ACTIVITY_ORDER.forEach((id) => {
    const idx = data.findIndex((activity) => id === activity.id)
    if (idx !== -1) {
      const [spliced] = data.splice(idx, 1)
      priorityData.push(spliced!)
    }
  })

  return [...priorityData, ...data]
}
